module.exports = {
    STORE_KEY: "n-", //缓存key
    FILE_SIZE: 5000 * 1024
};
